import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

/**
 * design-system.md's `TimeSelect` — pick a time of day from a fixed list
 * instead of typing one. `id`/`placeholder` are optional with no default,
 * so this component is byte-for-byte the documented contract from its first
 * consumer (warehouse.md's «Час знищення») rather than a cut-down version.
 */
export function TimeSelect({
  disabled,
  id,
  onValueChange,
  options,
  placeholder,
  value,
}: {
  value: string
  onValueChange: (value: string) => void
  options: string[]
  disabled?: boolean
  id?: string
  placeholder?: string
}) {
  return (
    <Select disabled={disabled} onValueChange={onValueChange} value={value}>
      <SelectTrigger className="w-full" id={id}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="max-h-[266px]" position="popper">
        {options.map((option) => (
          <SelectItem key={option} value={option}>
            {option}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
